import { queryOptions } from '@tanstack/react-query'

import { fetchVenueTrustSignalDetails } from '~/client/venue/venue-trust-signal.api'
import type { VenueTrustSignalDomain } from '~/shared/venue/trust-signals'

export const venueTrustSignalQueries = {
  details: (venueId: number | null | undefined, sourceDomain: VenueTrustSignalDomain | null) =>
    queryOptions({
      queryKey: ['venue-trust-signal', 'details', venueId ?? null, sourceDomain] as const,
      queryFn: ({ signal }) => {
        if (!venueId || !sourceDomain) {
          throw new Error('Missing venue trust signal query input')
        }

        return fetchVenueTrustSignalDetails({ venueId, sourceDomain, signal })
      },
      enabled: Boolean(venueId && sourceDomain),
      staleTime: 5 * 60_000,
    }),
}
